import { AddToCartStatus } from '@components/Button/AddToCart';
import React, {
  type ReactElement,
  type ReactNode,
  useReducer,
  useState,
} from 'react';

export interface UIContextInterface {
  quickCartIsOpen: boolean;
  setQuickCartIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  recentlyViewedIsOpen: boolean;
  setRecentlyViewedIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  recentlyViewedUpdates: number;
  updatedRecentlyViewed: React.DispatchWithoutAction;
  menuIsOpen: boolean;
  setMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addingToCartStatus: AddToCartStatus;
  setAddingToCartStatus: React.Dispatch<React.SetStateAction<AddToCartStatus>>;
  menuBreadcrumbs: string[];
  setMenuBreadcrumbs: React.Dispatch<React.SetStateAction<string[]>>;
  headerHeight: number | undefined;
  setHeaderHeight: React.Dispatch<React.SetStateAction<number | undefined>>;
  headerScrollClass: string;
  setHeaderScrollClass: React.Dispatch<React.SetStateAction<string>>;
}

// Create a recently viewed context
const UIContext = React.createContext<UIContextInterface>(
  {} as UIContextInterface
);

export function UIContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  // we need to stick state in here
  const [quickCartIsOpen, setQuickCartIsOpen] = useState(false);
  const [recentlyViewedIsOpen, setRecentlyViewedIsOpen] = useState(false);
  const [recentlyViewedUpdates, updatedRecentlyViewed] = useReducer(
    (state: number) => state + 1,
    0
  );
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [addingToCartStatus, setAddingToCartStatus] = useState(
    AddToCartStatus.None
  );
  const [menuBreadcrumbs, setMenuBreadcrumbs] = useState<string[]>([]);
  const [headerHeight, setHeaderHeight] = useState<number | undefined>();
  const [headerScrollClass, setHeaderScrollClass] = useState<string>('show');

  return (
    <UIContext.Provider
      value={{
        quickCartIsOpen,
        setQuickCartIsOpen,
        recentlyViewedIsOpen,
        setRecentlyViewedIsOpen,
        recentlyViewedUpdates,
        updatedRecentlyViewed,
        menuIsOpen,
        setMenuIsOpen,
        addingToCartStatus,
        setAddingToCartStatus,
        menuBreadcrumbs,
        setMenuBreadcrumbs,
        headerHeight,
        setHeaderHeight,
        headerScrollClass,
        setHeaderScrollClass,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export { UIContext };
